import React, { useEffect, useState} from "react";
import {createI18n, I18NContext, LocaleProvider} from "@spotify-internal/i18n-core";
import moment from "moment";
import {CurrentLocaleContext} from "./CurrentLocale";

const translationsBackend = {
  type: 'backend' as const,
  async read(locale: string, _ns: any, callback: any) {
    try {
      // Fallback to inline strings when loading english
      if (locale === 'en') {
        return callback(null, {});
      }

      return callback(null, await import(`../translations/${locale}/strings.json`));
    } catch (err) {
      // Fallback to inlined strings on error
      return callback(null, {});
    }
  },
};
export const i18nFactory = () => createI18n({}, translationsBackend);

export const I18nWrapper = ({ children, i18n }: {
  children: React.ReactNode
  i18n: any,
}) => {
  let firstLocale = localStorage.getItem('LOCALE');
  if (firstLocale === 'null' || firstLocale == null) {
    firstLocale = 'en';
  }

  const [currentLocale, setCurrentLocale] = useState(() => {
    moment.locale(firstLocale!);
    localStorage.setItem('LOCALE', firstLocale!);
    return firstLocale!
  });

  useEffect(() => {
    localStorage.setItem('LOCALE', currentLocale);
    moment.locale(currentLocale);
  }, [currentLocale]);

  return (
      <I18NContext.Provider value={i18n}>
        <CurrentLocaleContext.Provider
            value={{
              currentLocale,
              setCurrentLocale: setCurrentLocale,
            }}
        >
          <LocaleProvider value={currentLocale}>
            {children}
          </LocaleProvider>
        </CurrentLocaleContext.Provider>
      </I18NContext.Provider>
  );
};